module.exports = __webpack_public_path__ + "static/media/design1.775236c6.png";